import React from 'react';
import { Link } from 'react-router-dom';
import { formatPublicRosterCount } from '../../utils/registrationStatus';
import type { PublicRosterPayload } from '../../types/event';

interface EventPublicRosterProps {
  roster?: PublicRosterPayload | null;
}

const EventPublicRoster: React.FC<EventPublicRosterProps> = ({ roster }) => {
  const visibility = roster?.visibility || 'hidden';
  if (visibility === 'hidden') return null;

  const count = Number(roster?.count || 0);
  const headline = formatPublicRosterCount(count, roster?.capacity);
  const entries = visibility === 'list' ? roster?.entries || [] : [];

  return (
    <section className="mb-8" aria-labelledby="event-public-roster-heading">
      <h2 id="event-public-roster-heading" className="heading-section mb-3">
        Registered builds
      </h2>
      <p className="text-muted text-sm mb-4">{headline}</p>
      {visibility === 'list' ? (
        entries.length === 0 ? (
          <p className="text-muted text-sm">No confirmed builds yet.</p>
        ) : (
          <ul className="divide-y divide-white/[0.06] border border-white/[0.06] rounded-xl overflow-hidden">
            {entries.map((entry, index) => {
              const href =
                entry.owner_username && entry.public_slug
                  ? `/${entry.owner_username}/${entry.public_slug}`
                  : null;
              const body = (
                <>
                  <p className="font-medium text-white">{entry.vehicle_label}</p>
                  <p className="text-sm text-gray-500 mt-0.5">
                    {entry.owner_username ? `@${entry.owner_username}` : 'Owner hidden'}
                    {entry.class_name ? ` · ${entry.class_name}` : ''}
                  </p>
                </>
              );
              return (
                <li key={`${entry.owner_username || 'build'}-${entry.vehicle_label}-${index}`}>
                  {href ? (
                    <Link
                      to={href}
                      className="block px-4 py-3.5 bg-[#0c0c0c]/40 hover:bg-[#141414] min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/50"
                    >
                      {body}
                    </Link>
                  ) : (
                    <div className="px-4 py-3.5 bg-[#0c0c0c]/40">{body}</div>
                  )}
                </li>
              );
            })}
          </ul>
        )
      ) : null}
    </section>
  );
};

export default EventPublicRoster;
